"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PoiMarker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMapGl = require("react-map-gl");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTooltip = _interopRequireDefault(require("nicbase-tooltip"));

var _nicbaseTooltipData = require("nicbase-tooltip-data");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PoiMarker = function PoiMarker(_ref) {
  var _feature$properties;

  var feature = _ref.feature,
      lat = _ref.lat,
      lng = _ref.lng,
      start = _ref.start,
      end = _ref.end,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave;
  var tooltipRef = (0, _react.useRef)();

  var renderPoiType = function renderPoiType() {
    if (start) {
      return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.MarkerStart, {
        "aria-label": "startMarker",
        className: "h-8 transform -translate-y-3 fill-primary"
      });
    } else if (end) {
      return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.MarkerEnd, {
        "aria-label": "endMarker",
        className: "h-8 transform -translate-y-3 fill-primary"
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.POIWithText, {
      "aria-label": "poiMarker",
      type: 120,
      className: "h-8 transform -translate-y-3"
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_reactMapGl.Marker, {
    latitude: lat,
    longitude: lng
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute cursor-pointer transform -translate-y-1/2 -translate-x-1/2 transition-all duration-100 hover:scale-110"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    ref: tooltipRef,
    onMouseEnter: function onMouseEnter() {
      _onMouseEnter();

      (0, _nicbaseTooltipData.showTooltip)(tooltipRef.current);
    },
    onMouseLeave: function onMouseLeave() {
      _onMouseLeave();

      (0, _nicbaseTooltipData.hideTooltips)();
    },
    "data-for": "tourboard-route-section-tooltip-".concat(feature === null || feature === void 0 ? void 0 : (_feature$properties = feature.properties) === null || _feature$properties === void 0 ? void 0 : _feature$properties.wayPointId),
    "data-tip": "",
    "data-event": "focus"
  }, renderPoiType()), /*#__PURE__*/_react["default"].createElement(_nicbaseTooltip["default"], {
    id: "tourboard-route-section-tooltip-".concat(feature.properties.wayPointId),
    data: /*#__PURE__*/_react["default"].createElement(_nicbaseTooltipData.PoiData, {
      poi: feature.properties
    })
  })));
};

exports.PoiMarker = PoiMarker;

var noop = function noop() {};

PoiMarker.propTypes = {
  feature: _propTypes["default"].shape({
    properties: _propTypes["default"].shape({
      wayPointId: _propTypes["default"].number
    })
  }).isRequired,
  lat: _propTypes["default"].number.isRequired,
  lng: _propTypes["default"].number.isRequired,
  start: _propTypes["default"].bool.isRequired,
  end: _propTypes["default"].bool.isRequired,
  onMouseEnter: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func
};
PoiMarker.defaultProps = {
  onMouseEnter: noop,
  onMouseLeave: noop
};
var _default = PoiMarker;
exports["default"] = _default;